import { render } from "./backTop.vue?vue&type=template&id=f7b61a3a&ts=true"
import script from "./backTop.vue?vue&type=script&lang=ts"
export * from "./backTop.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\develop\\EBIEarthWebApp\\n-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__